import React from "react";
import courseDetails from "../../images/courses-details.jpg";
import circle from "../../images/circle-shape.png";
import author from "../../images/author-03.jpg";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape14 from "../../images/shape-14.png";
import logo from "../../images/logo.png";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
const CourseDetails = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  // console.log (id)
  const [courseDet, setcourseDet] = useState([]);
  const [Duration, setDuration] = useState([]);

  function Nav(s) {
    navigate("/courseLec/" + s);
  }
  console.log(id);
  async function getcourseDet() {
    let { data } = await axios.get(
      "https://maps-medics-be.onrender.com/show_topics/" + id
    );

    setcourseDet(data.result);
    console.log(data.result);
    setDuration(data)
  }

  // let currentIndex = 0;
  // console.log(lightContainer);
  useEffect(() => {
    getcourseDet();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  //   document.addEventListener("keyup", function (e) {
  //     var keyCode = e.keyCode ? e.keyCode : e.which;
  //             if (keyCode == 44) {
  //                 stopPrntScr();
  //             }
  //         });
  // function stopPrntScr() {
  // console.log('hereeee')
  //             var inpFld = document.createElement("input");
  //             inpFld.setAttribute("value", ".");
  //             inpFld.setAttribute("width", "0");
  //             inpFld.style.height = "0px";
  //             inpFld.style.width = "0px";
  //             inpFld.style.border = "0px";
  //             document.body.appendChild(inpFld);
  //             inpFld.select();
  //             document.execCommand("copy");
  //             inpFld.remove(inpFld);
  //         }
  //        function AccessClipboardData() {
  //             try {
  //                 window.clipboardData.setData('text', "Access   Restricted");
  //             } catch (err) {
  //             }
  //         }
  //         setInterval("AccessClipboardData()", 300);

  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    const formattedDuration = [];
    if (hours > 0) {
      formattedDuration.push(`${hours}h`);
    }
    if (minutes > 0) {
      formattedDuration.push(`${minutes}m`);
    }
    if (seconds > 0) {
      formattedDuration.push(`${seconds}s`);
    }

    return formattedDuration.join(" ");
  };
  return (
    <>
      {/* <Navbar/> */} <div className="section "></div>
      <div class="section page-banner">
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.4)",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            class="container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="page-banner-content">
              <h2 class="title" style={{ color: "#fff" }}>
                Our <span>Course.</span>
              </h2>
              {/* {name.replace("%20"," ")} */}
            </div>
          </div>
        </div>
      </div>
      <div class="section  " style={{ paddingBottom: "3%" }}>
        <div class="container">
          <div className="row">
            <h5
              style={{
                color: "#212529",
                fontSize: "21px",
                fontWeight: "700",
                fontFamily: "Playfair Display",
                paddingTop: "5%",
              }}
            >
              My Topics
            </h5>
            <hr />
            <div style={{ display: "flex", justifyContent: "start" }}>
              {" "}
              {courseDet.map((p, index) => (
                <a
                  className="col-md-6"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={() => Nav(p.id)}
                >
                  <div
                    className="p-3"
                    value={p.id}
                    key={index}
                    onClick={() => {
                      sessionStorage.setItem("course_image", p.image);
                    }}
                  >
                    {/* <div class="card" >
<img  src={p.image} class="card-img-top" style={{cursor:'pointer'}} alt="..."/>
<div class="card-body" style={{backgroundColor:'rgba(255, 255, 255, 0.3)'}}>
<a  style={{color:'#212529', fontSize:'21px', margin:'0px 0px 14px 0px', fontWeight:'700', cursor:'pointer'}}>{p.name}</a>
<p style={{ color:'rgb(32, 33, 34)', fontSize:'14px', fontWeight:'400', marginTop:'0.50rem'}} class="card-text">{p.description}</p>
</div>
<div className="card-footer" style={{borderRadius:'0 0 calc(0.25rem - 1px) calc(0.25rem - 1px)' , backgroundColor:'#FFFFFF', color:'#6C757D'}}>
<div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
<small style={{fontWeight:'700'}}>5 Hours 52 minutes</small>
</div>
</div>
</div>  */}

                    <div class="cardtopic" style={{padding:'10px'}}>
                      <img src={p.image} alt="Example Image" />
                      <div class="description">
                        <a
                          style={{
                            color: "#212529",
                            fontSize: "21px",
                            margin: "0px 0px 14px 0px",
                            fontWeight: "700",
                            cursor: "pointer",
                            textDecoration:'none',
                          }}
                          className="p-1"
                        >
                          {p.name}
                        </a>
                        <p
                          style={{
                            color: "rgb(32, 33, 34)",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                          class="card-text p-1"
                        >
                          {p.description}
                        </p>
                      </div>
                      <div
                        className="card-footer"
                        style={{
                          borderRadius:
                            "0 0 calc(0.25rem - 1px) calc(0.25rem - 1px)",
                          backgroundColor: "#FFFFFF",
                          color: "#6C757D",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <small style={{ fontWeight: "700" }}>
                            Duration: <br />
                          {formatDuration(Duration.duration)} 
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default CourseDetails;
